/**
 * Created by YangMing on 24/04/04.
 * Token管理
 */
import Cookies from 'js-cookie'

const TokenKey = 'joyplay_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
